import React, { useMemo } from 'react';
import {
	WorkplaceDoctorStatisticsCaseInsurance,
	WorkplaceDoctorStatisticsData,
} from '../Hooks/useWorkplaceDoctorStatistics';
import { ITableColumn } from '../../../Models/Table/ITableColumn';
import ScrollableDataTable from '../../Base/Components/ScrollableDataTable/ScrollableDataTable';
import Text from '../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './WorkplaceDoctorStatisticsTable.module.scss';
import WorkplaceDoctorStatisticsTableItem from './WorkplaceDoctorStatisticsTableItem';

interface Row {
	name: string;
	[key: string]: string;
}

interface Props {
	data: WorkplaceDoctorStatisticsData[];
}

const COLUMNS: ITableColumn[] = [
	{
		key: 'name',
		renderItem: (item: { name: string }) => (
			<Text tx={item.name} className={styles.name} />
		),
	},
	{
		key: 'child',
		title: 'component.workplaceDoctorStatisticsTable.head.child',
		renderItem: (item: { child: string }) => (
			<WorkplaceDoctorStatisticsTableItem value={item.child} />
		),
	},
	{
		key: 'adult',
		title: 'component.workplaceDoctorStatisticsTable.head.adults',
		renderItem: (item: { adult: string }) => (
			<WorkplaceDoctorStatisticsTableItem value={item.adult} />
		),
	},
	{
		key: 'total',
		title: 'component.workplaceDoctorStatisticsTable.head.total',
		renderItem: (item: { total: string }) => (
			<WorkplaceDoctorStatisticsTableItem value={item.total} />
		),
	},
];

const labels: Record<string, string> = {
	caseSolved: 'component.workplaceDoctorStatisticsTable.row.caseSolved',
	caseReassigned: 'component.workplaceDoctorStatisticsTable.row.caseReassigned',
	insuranceReport:
		'component.workplaceDoctorStatisticsTable.row.insuranceReport',
	prescription: 'component.workplaceDoctorStatisticsTable.row.prescription',
};

const WorkplaceDoctorStatisticsTable: React.FC<Props> = ({ data }) => {
	const prepareCaseInsurance = (
		data: WorkplaceDoctorStatisticsCaseInsurance[],
	): Row[] => {
		return data.flatMap(item => {
			return [
				{
					name: item.insuranceCompanyCode,
					...item.count,
				},
			];
		});
	};

	const isCaseInsurance = (
		item: WorkplaceDoctorStatisticsData,
	): item is Extract<
		WorkplaceDoctorStatisticsData,
		{ key: 'caseInsurance' }
	> => {
		return item.key === 'caseInsurance';
	};

	const prepareRows = (data: WorkplaceDoctorStatisticsData[]): Row[] =>
		data.flatMap(item =>
			isCaseInsurance(item)
				? prepareCaseInsurance(item.value)
				: [{ name: labels[item.key] ?? item.key, ...item.value }],
		);

	const rows = useMemo(() => prepareRows(data), [data]);

	return (
		<ScrollableDataTable
			columns={COLUMNS}
			rows={rows}
			firstColumnFixed={false}
		/>
	);
};

export default WorkplaceDoctorStatisticsTable;
